export default __webpack_public_path__ + "static/media/founder1.97fae17e.png";